import { render } from "./BattleLoading.vue?vue&type=template&id=10c4dff2"
import script from "./BattleLoading.vue?vue&type=script&lang=js"
export * from "./BattleLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__